
import React, { useEffect } from 'react';
import { Button } from "react-bootstrap";
import PropTypes from "prop-types";


EliminaNota.propTypes = {
    nota: PropTypes.object,
    close: PropTypes.func,
    action: PropTypes.func
}

function EliminaNota({ nota, close, action, setMessage }) {

    useEffect(() => {
        setMessage([]);
    }, [setMessage]);

    return (
        <div className="formGroup" id="nota">
            <p className="text-center">Confermando la nota verrà cancellata definitivamente</p>
            <div className="buttonPopup">
                <Button className="btnGenerale" variant="flat" size="sm" id="cancella-nota"
                    onClick={() => { action(nota, close) }}>Conferma</Button>
                <Button className="btnGenerale" variant="flat" size="sm" id="annulla"
                    onClick={close}>Annulla</Button>
            </div>
        </div>)
}



export default EliminaNota;